"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageReportFilterUnit = exports.HyperPasteSyncSourceFileStatus = exports.VoucherSearchBelongsTo = exports.VoucherLanguageType = exports.VoucherHyperPasteVersion = exports.VoucherFileType = exports.VoucherUnitFileStatus = exports.VoucherSourceFileStatus = exports.VoucherLoadActionStatus = exports.VoucherRegistrationNumberStatus = exports.getVoucherStatus = exports.isUnprocessed = exports.VoucherStatus = exports.VoucherVendor = exports.VoucherType = void 0;
var VoucherType;
(function (VoucherType) {
    VoucherType["UNKNOWN"] = "unknown";
    VoucherType["RECEIPT"] = "receipt";
    VoucherType["INVOICE"] = "invoice";
    VoucherType["TEMPLATE"] = "template";
    VoucherType["WATER_INVOICE"] = "waterInvoice";
    VoucherType["SYSTEM"] = "system";
})(VoucherType = exports.VoucherType || (exports.VoucherType = {}));
var VoucherVendor;
(function (VoucherVendor) {
    VoucherVendor["ROBOTA"] = "robota";
    VoucherVendor["PEPPOL"] = "peppol";
})(VoucherVendor = exports.VoucherVendor || (exports.VoucherVendor = {}));
var VoucherStatus;
(function (VoucherStatus) {
    VoucherStatus["WAITING"] = "waiting";
    VoucherStatus["LOADING"] = "loading";
    VoucherStatus["LOAD_ERROR"] = "loadError";
    // WAITING_FOR_DEPARTMENT _assignee role_
    VoucherStatus["WAITING_TO_BE_ASSIGNED"] = "waitingToBeAssigned";
    // UNCONFIRMED? UNCHECKED? UNSTARTED
    //UNSUPPORTED = "unsupported", // 未対応
    VoucherStatus["UNPROCESSED"] = "unprocessed";
    //CHECKED = "checked", // 確認済み
    VoucherStatus["WAITING_APPROVAL"] = "waitingApproval";
    VoucherStatus["APPROVED"] = "approved";
    VoucherStatus["EXPORTING"] = "exporting";
    VoucherStatus["EXPORTED"] = "exported";
    VoucherStatus["EXPORT_ERROR"] = "exportError";
    VoucherStatus["ARCHIVED"] = "archived";
    VoucherStatus["SUBMITTED"] = "submitted";
})(VoucherStatus = exports.VoucherStatus || (exports.VoucherStatus = {}));
// backward compatibility function.
var isUnprocessed = function (status) {
    switch (status) {
        case "checked":
            return true;
        case VoucherStatus.UNPROCESSED:
            return true;
    }
    return false;
};
exports.isUnprocessed = isUnprocessed;
// backward compatibility function.
var getVoucherStatus = function (status) {
    switch (status) {
        case "checked":
            return VoucherStatus.UNPROCESSED;
        case VoucherStatus.UNPROCESSED:
            return VoucherStatus.UNPROCESSED;
    }
    return status || VoucherStatus.UNPROCESSED;
};
exports.getVoucherStatus = getVoucherStatus;
// codes from https://fastaccounting.atlassian.net/browse/MS-4179
var VoucherRegistrationNumberStatus;
(function (VoucherRegistrationNumberStatus) {
    /*1-A*/ VoucherRegistrationNumberStatus["REGISTERED_NUMBER_SHOULD_DESCRIBED"] = "REGISTERED_NUMBER_SHOULD_DESCRIBED";
    /*1-B*/ VoucherRegistrationNumberStatus["NOT_SUBJECT"] = "NOT_SUBJECT";
    /*1-C*/ VoucherRegistrationNumberStatus["PERIOD_NOT_EXISTS"] = "PERIOD_NOT_EXISTS";
    /*1-D*/ VoucherRegistrationNumberStatus["ADDRESS_NOT_REGISTERED"] = "ADDRESS_NOT_REGISTERED";
    /*1-E*/ VoucherRegistrationNumberStatus["NAME_NOT_REGISTERED"] = "NAME_NOT_REGISTERED";
    /*2-A*/ VoucherRegistrationNumberStatus["VALID"] = "VALID";
    /*2-B*/ VoucherRegistrationNumberStatus["INVALID_PERIOD"] = "INVALID_PERIOD";
    /*2-C*/ // PERIOD_NOT_EXISTS
    /*2-D*/ VoucherRegistrationNumberStatus["NOT_MATCHED_TO_NAME"] = "NOT_MATCHED_TO_NAME";
    /*2-E*/ VoucherRegistrationNumberStatus["NOT_MATCHED_TO_NUMBER"] = "NOT_MATCHED_TO_NUMBER";
})(VoucherRegistrationNumberStatus = exports.VoucherRegistrationNumberStatus || (exports.VoucherRegistrationNumberStatus = {}));
exports.VoucherLoadActionStatus = {
    WAITING: "waiting",
    LOADING: "loading",
    PROCESSING: "processing",
    DISTRIBUTING: "distributing",
    FINISHED: "finished",
    ERROR: "error",
    RETRY: "retry",
};
exports.VoucherSourceFileStatus = {
    SOURCE_WAITING: "sourceWaiting",
    SOURCE_LOADING: "sourceLoading",
    SOURCE_ERROR: "sourceError",
    SOURCE_DONE: "sourceDone",
    // 元ファイルを振分にかける
    DISTRIBUTION_WAITING: "distributionWaiting",
    DISTRIBUTION_DONE: "distributionDone",
    // 特に何もする必要なし（Remota API で取り込まれたファイルなど）
    NOTHING: "nothing",
};
exports.VoucherUnitFileStatus = {
    WAITING: "waiting",
    PROCESSING: "processing",
    DONE: "done",
    ERROR: "error",
    RETRY: "retry",
};
exports.VoucherFileType = {
    OCR: "ocr",
    DISPLAY: "display",
    ATTACHMENT: "attachment",
};
exports.VoucherHyperPasteVersion = {
    V0_5: "v0.5",
    V1_0: "v1.0",
};
exports.VoucherLanguageType = {
    JPN: "jpn",
    ENG: "eng",
};
exports.VoucherSearchBelongsTo = {
    ME: "me",
    ALL: "all",
};
exports.HyperPasteSyncSourceFileStatus = {
    WAITING: "waiting",
    PROCESSING: "processing",
    FINISHED: "finished",
};
exports.UsageReportFilterUnit = {
    USER: "user",
    DEPARTMENT: "department",
};
